module.exports = __webpack_public_path__ + "static/media/galerija_2021 (15)-min.87702394.jpg";